import {
  ADD_ITEM_TO_TEMP_CART,
  REMOVE_ITEM_TO_TEMP_CART,
  CLEAR_ITEMS_IN_TEMP_CART
} from "../actions";

export function addItemToTempCart(payload) {
  return {
    type: ADD_ITEM_TO_TEMP_CART,
    payload
  };
}

export function removeItemFromTempCart(payload) {
  return {
    type: REMOVE_ITEM_TO_TEMP_CART,
    payload
  };
}

export function clearItemsInTempCart() {
  return {
    type: CLEAR_ITEMS_IN_TEMP_CART
  };
}



// WEBPACK FOOTER //
// ./src/store/actionCreators/tempCart.js